import * as dataTypes from 'utils/constants'
import { insertIf } from 'utils/types'

export const mapResponseToResource = (data, resource) => {
  switch (resource) {
    case dataTypes.REFERENCE_PARAMETER: {
      return data.map((d) =>
        d.merge({
          status: d.get('status').split(',').pop(),
        })
      )
    }
    default: {
      return data
    }
  }
}

const defaultSortMethod = (a, b) => {
  // force null and undefined to the bottom
  let aValue = a === null || a === undefined ? '' : a
  let bValue = b === null || b === undefined ? '' : b
  // force any string values to lowercase
  aValue = typeof aValue === 'string' ? aValue.toLowerCase() : aValue
  bValue = typeof bValue === 'string' ? bValue.toLowerCase() : bValue

  if (typeof aValue === 'number' && typeof bValue === 'number')
    return aValue - bValue
  if (typeof aValue === 'string' && typeof bValue === 'string')
    return aValue.localeCompare(bValue, { sensitivity: 'variant' })
  return 0
}

const doSort = (data, sortMethods, dirs) =>
  data.sort((rowA, rowB) => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < sortMethods.length; i++) {
      const sortFunc = sortMethods[i]
      const desc = dirs[i] === false || dirs[i] === 'desc'
      const sortInt = sortFunc(rowA, rowB)
      if (sortInt) {
        return desc ? -sortInt : sortInt
      }
    }

    return 0
  })

export const sortData = (data, sorted) => {
  if (!sorted.length) {
    return data
  }

  const sortedData = doSort(
    data,
    sorted.map((sort) => (a, b) => defaultSortMethod(a[sort.id], b[sort.id])),
    sorted.map((d) => !d.desc)
  )

  sortedData.forEach((row) => {
    // eslint-disable-next-line no-underscore-dangle
    if (!row._subRows) {
      return
    }
    // eslint-disable-next-line no-underscore-dangle
    row._subRows = this.sortData(row._subRows, sorted)
  })

  return sortedData
}

export const getFilteredPreProdVehicleList = (vehicles = []) => {
  if (vehicles.length === 0) return { preProd: [], nonPreProd: [] }

  return vehicles.reduce(
    (acc, curr) => ({
      preProd: [...acc.preProd, ...insertIf(curr.isPreProduction, curr)],
      nonPreProd: [...acc.nonPreProd, ...insertIf(!curr.isPreProduction, curr)],
    }),
    { preProd: [], nonPreProd: [] }
  )
}
